import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Beaver Creek",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10075",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Daylight",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9272",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Keep Going",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9222",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Nightfall",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg",
      artist: "Aiguille",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9148",
      color: ["#EF8EA9", "#ab417f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Reflection",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg",
      artist: "Swørn",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=9228",
      color: ["#CD607D", "#c94043"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Under the City Stars",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg",
      artist: "Aso, Middle School, Aviino",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=10074",
      color: ["#205950", "#2ab3bf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Vitamin D",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/3b73a510169f14c4af83ac4016e809917412702b-300x300.jpg",
      artist: "fantompower",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22791",
      color: ["#d8b2d7", "#ccdedf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Solar Cave",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/03/d7ee494a68e5ff81082460680db4944f2ade6497-300x300.jpg",
      artist: "Mama Aiuto",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=16179",
      color: ["#ce4b46", "#feaf86"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Lagoons",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/06/49f6e32ca521fbad46a1b281e3893cf6254bf11d-300x300.jpg",
      artist: "Strehlow, Chris Mazuera",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=8266",
      color: ["#412937", "#d8bfc2"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Gratitude",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/3b73a510169f14c4af83ac4016e809917412702b-300x300.jpg",
      artist: "fantompower",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22792",
      color: ["#d8b2d7", "#ccdedf"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Collages",
      cover:
        "https://chillhop.com/wp-content/uploads/2020/07/cd6ad456b39b442e4d39e346c5f778df969326e6-300x300.jpg",
      artist: "Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=7985",
      color: ["#0096a4", "#d3455f"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Shine",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/034f52eeaeceb144cca67b0930d705d32fc39e37-1024x1024.jpg",
      artist: "Ruck P, The Kount",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=20565",
      color: ["#372e3a", "#957a7d"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Chit Chat",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/5821e04fd52fa668a0b9890f213cbb12e454cc6b-1024x1024.jpg",
      artist: "Middle School",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22934",
      color: ["#bf5837", "#253f56"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Same Old Circles",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/5821e04fd52fa668a0b9890f213cbb12e454cc6b-1024x1024.jpg",
      artist: "Middle School",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22935",
      color: ["#bf5837", "#253f56"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "sozu",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/05/1245c0271290a3196328c0cf4aaa910cd873dfe7-1024x1024.jpg",
      artist: "mommy, Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=19062",
      color: ["#5e8ed0", "#fed8c3"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "travelbag",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/05/1245c0271290a3196328c0cf4aaa910cd873dfe7-1024x1024.jpg",
      artist: "mommy, Sleepy Fish",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=19058",
      color: ["#5e8ed0", "#fed8c3"],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default chillHop;
